import { getMerchantId } from 'util/merchant-id';
import {
  GetRecommendationsTopItemsResponse,
  EmailPulseDataResponse,
  OfferTrendsParams,
  RecommendationsReportRequestParams,
} from './reports-service.types';

const getSalesByListTotal = salesByDateList => {
  let totalTransactions = 0;
  let totalAmount = 0;
  salesByDateList?.forEach(e => {
    totalTransactions += e.totalOrders;
    totalAmount += e.totalSales;
  });
  return {
    transactions: totalTransactions,
    amount: totalAmount,
  };
};

export const transformSalesByLocationData = response => {
  response.forEach(location => {
    const totalAmount = getSalesByListTotal(location?.salesByDateList);
    location.transactions = totalAmount.transactions;
    location.amount = totalAmount.amount;
  });
  return response;
};

export const getSalesByLocationParams = params => ({
  ...params,
  merchantId: getMerchantId(),
});

export const getOffersTrendsParams = ({
  offerdatatype,
  ...rest
}: OfferTrendsParams) => ({
  ...rest,
  datatype: offerdatatype,
});

export const getRecommendationReportParams = (
  params: RecommendationsReportRequestParams,
) => {
  return {
    ...params,
    merchantId: getMerchantId(),
  };
};

const getDecile = (row, field, min, max) => {
  let decile = Math.ceil(((row[field] - min) * 10) / (max - min)) - 1;
  decile = Math.min(decile, 9);
  decile = Math.max(decile, 0);
  return decile;
};

export const transformRecommendationsTopItems = (
  data: GetRecommendationsTopItemsResponse,
  params: RecommendationsReportRequestParams,
) => {
  if (data.length === 0 || params?.excludeZeroDollar) return data;

  let takeRateMin = data[0]['takeRate'];
  let takeRateMax = data[0]['takeRate'];
  let revenueMin = data[0]['revenue'];
  let revenueMax = data[0]['revenue'];
  let ordersMin = data[0]['orders'];
  let ordersMax = data[0]['orders'];
  let qtyMin = data[0]['qty'];
  let qtyMax = data[0]['qty'];
  data.forEach(row => {
    takeRateMin = Math.min(takeRateMin, row['takeRate']);
    takeRateMax = Math.max(takeRateMax, row['takeRate']);
    revenueMin = Math.min(revenueMin, row['revenue']);
    revenueMax = Math.max(revenueMax, row['revenue']);
    ordersMin = Math.min(ordersMin, row['orders']);
    ordersMax = Math.max(ordersMax, row['orders']);
    qtyMin = Math.min(qtyMin, row['qty']);
    qtyMax = Math.max(qtyMax, row['qty']);
  });

  return data.map(row => ({
    ...row,
    deciles: {
      takeRate: getDecile(row, 'takeRate', takeRateMin, takeRateMax),
      revenue: getDecile(row, 'revenue', revenueMin, revenueMax),
      orders: getDecile(row, 'orders', ordersMin, ordersMax),
      qty: getDecile(row, 'qty', qtyMin, qtyMax),
    },
  }));
};

// RTK Query invokes providesTags with an undefined result whenever the query
// errors or is aborted (e.g. the component unmounts while the request is still
// in flight). Guard the same way util/generateTags does, so we still return the
// LIST tag rather than throwing on `result.data`.
export const getEmailPulseDataTags = (
  result: EmailPulseDataResponse | undefined,
  reportType: string,
) => {
  const tagType = `EmailPulse-${reportType}`;
  return [
    ...(result?.data ?? []).map(row => ({
      type: tagType as any,
      id: row.id,
    })),
    { type: tagType as any, id: 'LIST' },
  ];
};
